// @ts-nocheck TODO

import {html} from "lit";
import {customElement, property} from "lit/decorators.js";
import {repeat} from "lit/directives/repeat.js";
import {MobxLitElement} from "@adobe/lit-mobx";

import "./OutlineSection.js";
import "../common/controls-inputs/IconButton.js";
import "../common/controls-inputs/Select.js";

import Data from "../../main/data/index.js";
import {getVirtualOutline} from "./outline_util.js";
import UI_MODES from "./ui_modes.js";
import {mergedOutline2} from "../../main/data/model/index.js";

@customElement("pn-outline")
export class Outline extends MobxLitElement {
	@property() annotation = {
		type:       "",
		ai:         false,
		renderable: true,
		pageData:   null,
		citation:   null
	};
	@property({type: Boolean}) isEditable = false;
	@property({type: Boolean}) isSidebarApiClosed = true;
	@property({type: Boolean}) showToolTip = false;
	@property({type: Boolean}) disabled = false;
	@property({type: UI_MODES}) mode:       UI_MODES;
	@property({type: String}) sortBy:       "topic" | "source" | "date" | "editor" = "topic";
	@property({type: String}) selectedView: "all" | "page" | "summary" | "bookmarks" = "all";
	@property() forceOutline:               mergedOutline2[] | false = false;

	protected createRenderRoot(): HTMLElement | DocumentFragment {
		return this;
	}

	render() {
		const project = Data.app.project;
		const outline = this.forceOutline || Data.app.outline;
		const me = Data.app.me;
		if (outline === undefined || me === undefined || project === undefined)
			return null;
		const topics = this.forceOutline
			? Object.values(outline
				.filter(ot => ot.topic)
				.map(ot => ot.topic)
			)
			: Data.app.topics;
		const sortBy = this.forceOutline ? "topic" : this.sortBy;
		const selectedView = this.forceOutline ? "all" : this.selectedView;
		const virtualOutline = getVirtualOutline(me, project, outline, topics, sortBy);

		switch (this.mode) {
			case UI_MODES.SIDEBAR:
			case UI_MODES.SIDEBAR_DRAG:
			case UI_MODES.SIDEBAR_READONLY:
				break;
			default:
				return "Unsupported outline mode: " + this.mode;
		}

		const getSectionKey = section => project.uuid + ":" + this.mode + ":" + section.label;

		return html`
			${repeat(virtualOutline, getSectionKey, section =>
				html`<pn-outline-section
					.isEditable=${this.isEditable}
					.section="${section}"
					.mode="${this.mode}"
					.selectedView="${selectedView}"
					.sortBy="${sortBy}"
				></pn-outline-section>`
			)}
		`;
	}
}

declare global {
	interface HTMLElementTagNameMap {
		"pn-outline": Outline;
	}
}
